if (!customElements.get('custom-select')) {
  customElements.define(
    'custom-select',
    class CustomSelect extends DetailsDisclosureBase {
      constructor() {
        super();
        this.handleClickItem = this.handleClickItem.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.hideSelectedItem = this.hideSelectedItem.bind(this);

        this.summaryText =
          this.querySelector('.custom-select__text') ||
          this.querySelector('summary');
        this.list = this.querySelector('ul');
        this.listItems = this.list.querySelectorAll('li');
      }

      connectedCallback() {
        this.bindEvents();
        this.hideSelectedItem();
      }

      bindEvents() {
        super.bindEvents();
        this.listItems.forEach(item => {
          item.tabIndex = 0;
          item.addEventListener('click', this.handleClickItem);
        });

        this.addEventListener('keydown', this.handleKeydown);
      }

      unbindEvents() {
        super.unbindEvents();
        this.listItems.forEach(item => {
          item.removeEventListener('click', this.handleClickItem);
        });

        this.removeEventListener('keydown', this.handleKeydown);
      }

      hideSelectedItem() {
        const selectedText = this.summaryText.textContent.trim();
        this.listItems.forEach(item => {
          if (item.textContent.trim() === selectedText) {
            item.style.display = 'none';
          } else {
            item.style.display = '';
          }
        });
      }

      handleKeydown(e) {
        if (e.key === ' ' || e.key === 'Enter') {
          this.handleClickItem(e);
        }
      }

      open() {
        gsap.set(this.list, { scaleY: 0, opacity: 0, transformOrigin: 'top' });
        super.open();
        gsap.to(this.list, {
          scaleY: 1,
          opacity: 1,
          delay: 0.01,
          duration: 0.3,
        });
      }

      close() {
        this.classList.add('is-closing');
        gsap.to(this.list, {
          scaleY: 0,
          duration: 0.18,
          onComplete: () => {
            super.close();
            this.classList.remove('is-closing');
          },
        });
      }

      handleClickItem(e) {
        let refocus = false;
        const value = e.target.innerText.trim();
        this.summaryText.innerText = value;

        if (document.activeElement.matches('li')) {
          refocus = true;
        }

        this.close();
        this.hideSelectedItem();

        const index = Array.from(this.list.children).indexOf(e.target);

        this.dispatchEvent(
          new CustomEvent('change', {
            bubbles: true,
            detail: {
              selectedValue: value,
              selectedIndex: index,
            },
          }),
        );

        window.setTimeout(() => {
          this.summaryElement.focus();
        });
      }
    },
  );
}
